<template>
  <div class="services-section">
    <div class="container">
      <h2 class="section-title">品牌策略+创意设计+营销推广</h2>
      <div class="section-underline">
        <span class="underline-text">strategy design promotion</span>
      </div>
      <div class="services-cards">
        <ul class="ul-pic-g1">
          <li v-for="(card, index) in serviceCards" :key="index">
            <div class="card-con" :style="card.bgImage ? { backgroundImage: `url(${card.bgImage})` } : {}">
              <h4>{{ card.title }}</h4>
              <div class="icon" v-if="card.icon">
                <img :src="card.icon" :alt="card.title" />
              </div>
              <div class="icon" v-else></div>
            </div>
          </li>
        </ul>
      </div>

      <div class="service-categories">
        <ul class="ul-lk-g1">
          <li v-for="(category, index) in categories" :key="index">
            <div class="con">
              <h4>{{ category.title }}</h4>
              <div class="lk">
                <a v-for="(item, idx) in category.items" :key="idx">{{ item }}</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Services',
  data() {
    return {
      serviceCards: [
        {
          title: '洞察',
          description: '深入市场调研，精准洞察品牌机会',
          bgImage: '',
          icon: ''
        },
        {
          title: '策略',
          description: '制定品牌战略，明确品牌定位',
          bgImage: '',
          icon: ''
        },
        {
          title: '设计',
          description: '创意视觉设计，打造品牌形象',
          bgImage: '',
          icon: ''
        },
        {
          title: '激活',
          description: '品牌传播推广，激活品牌价值',
          bgImage: '',
          icon: ''
        }
      ],
      categories: [
        {
          title: '品牌咨询',
          items: ['品牌表象分析', '品牌架构诊断', '品牌表现诊断', '品牌短板诊断', '品牌优化诊断']
        },
        {
          title: '品牌洞察',
          items: ['品牌生态洞察', '竞争品牌洞察', '消费群洞察', '品牌群洞察', '品牌核心价值洞察', '品牌力洞察']
        },
        {
          title: '品牌规划',
          items: ['品牌战略规划', '品牌架构规划', '品牌卖点策划', '品牌定位策划', '品牌价值策划', '品牌文化策划']
        },
        {
          title: '品牌塑造',
          items: ['品牌定位', '品牌价值', 'slogan', '品牌命名', '品牌空间', '品类创新', '产品线规划']
        },
        {
          title: '品牌形象系统',
          items: ['LOGO设计', 'VI设计', '超级IP吉祥物设计', 'KV海报设计', '包装设计', '导示/SI展厅设计', '画册设计', '网站设计']
        },
        {
          title: '品牌传播',
          items: ['关键字传播', '事件传播', '病毒传播', '互动传播', '线下传播']
        }
      ]
    }
  }
}
</script>

<style scoped>
.services-section {
  padding: 60px 0 80px;
  background: #fff;
}

.section-title {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

.section-title::after {
  display: none;
}

.section-underline {
  margin-top: 0;
  margin-bottom: 50px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.section-underline::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  height: 2px;
  background-color: #EA4043;
}

.underline-text {
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 4px;
  color: #666;
  background-color: #fff;
  padding: 0 20px;
  position: relative;
  z-index: 1;
  text-transform: lowercase;
}

.services-cards {
  margin: 0 -22px 80px;
  overflow: hidden;
}

.services-cards:after {
  content: '';
  display: block;
  clear: both;
  width: 100%;
  height: 0;
  visibility: hidden;
}

.ul-pic-g1 {
  margin: 0 -22px -20px;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
}

.ul-pic-g1:after {
  content: '';
  display: block;
  clear: both;
  width: 100%;
  height: 0;
  visibility: hidden;
}

.ul-pic-g1 li {
  float: left;
  width: 25%;
  margin-bottom: 20px;
  padding: 0 22px;
  box-sizing: border-box;
}

.ul-pic-g1 .card-con {
  padding: 27px 0 38px;
  text-align: center;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-color: #1a1a1a;
  transition: all 0.5s;
  border-radius: 4px;
  overflow: hidden;
}

.ul-pic-g1 h4 {
  font-size: 36px;
  color: #fff;
  font-weight: 400;
  line-height: 1.4;
  margin-bottom: 13px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.ul-pic-g1 .icon {
  width: 82px;
  height: 82px;
  border-radius: 50%;
  margin: 0 auto;
  transition: transform 0.5s;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
}

.ul-pic-g1 .icon img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.ul-pic-g1 .card-con:hover .icon {
  transform: rotate(45deg);
}

.ul-pic-g1 .card-con:hover {
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.3);
  transform: translateY(-5px);
}

.service-categories {
  margin-top: 71px;
}

.ul-lk-g1 {
  margin: 0 -16px -16px;
  padding: 0;
  list-style: none;
  font-size: 0;
  overflow: hidden;
}

.ul-lk-g1 li {
  display: inline-block;
  vertical-align: top;
  width: 16.66%;
  margin-bottom: 16px;
  box-sizing: border-box;
}

.ul-lk-g1 .con {
  margin: 0 16px;
}

.ul-lk-g1 h4 {
  font-size: 24px;
  color: #242526;
  line-height: 1.4;
  font-weight: 400;
  padding-bottom: 22px;
  margin-bottom: 16px;
  border-bottom: 2px solid #eeeeef;
  position: relative;
}

.ul-lk-g1 h4:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  right: 0;
  width: 80px;
  height: 2px;
  background-color: #EA4043;
}

.ul-lk-g1 .lk {
  overflow: hidden;
}

.ul-lk-g1 .lk a {
  display: block;
  font-size: 16px;
  color: #5b5b5b;
  line-height: 1.88;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  transition: color 0.5s;
  text-decoration: none;
  cursor: pointer;
}

.ul-lk-g1 .lk a:hover {
  color: #EA4043;
}

@media (max-width: 1200px) {
  .ul-pic-g1 h4 {
    font-size: 30px;
  }

  .ul-lk-g1 li {
    width: 33.33%;
  }

  .services-section {
    padding: 50px 0 70px;
  }
}

@media (max-width: 768px) {
  .services-section {
    padding: 40px 0 60px;
  }

  .service-categories {
    margin-top: 30px;
  }

  .ul-pic-g1 li {
    width: 50%;
  }

  .ul-pic-g1 .card-con {
    padding: 16px 0 20px;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  }

  .ul-pic-g1 h4 {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .ul-pic-g1 .icon {
    width: 40px;
    height: 40px;
  }

  .ul-lk-g1 {
    margin: 0 -10px -16px;
  }

  .ul-lk-g1 li {
    width: 50%;
  }

  .ul-lk-g1 .con {
    margin: 0 10px;
  }

  .ul-lk-g1 h4 {
    font-size: 18px;
    padding-bottom: 15px;
    margin-bottom: 10px;
  }

  .ul-lk-g1 h4:after {
    width: 40px;
  }

  .ul-lk-g1 .lk a {
    font-size: 14px;
    line-height: 2;
  }

  .section-title {
    font-size: 28px !important;
  }

  .section-underline::before {
    width: 150px;
  }

  .underline-text {
    font-size: 18px;
    letter-spacing: 2px;
    padding: 0 15px;
  }
}
</style>
